// extracted by mini-css-extract-plugin
export var container = "_dy-1";
export var cornerButtonContainer = "_dy-6";
export var disabled = "_dy-2";
export var dragActive = "_dy-3";
export var fileContainer = "_dy-5";
export var hiddenInput = "_dy-4";
export var widthContainer = "_dy-0";